<ds-featured-badge
  [title]="title"
  [description]="description"
  [imageSrc]="'/assets/images/' + img + '.webp'"
  imageAlt="option-full-badge-img"
  [tone]="type"
/>
